export const chunkArray = (arr: any[], chunkSize: number) =>
  arr.reduce(
    (acc, _, i) =>
      i % chunkSize ? acc : [...acc, arr.slice(i, i + chunkSize)],
    []
  );
